/*
 * Darci Native Session Sync Manager
 * Replaced external webogram/telegram sync logic with local mock
 */

export class DarciSessionSyncManager {
  public setAuthorized(canRedirect: boolean) {
    return Promise.resolve();
  }
}

const darciSessionSyncManager = new DarciSessionSyncManager();
export default darciSessionSyncManager;
